module.exports = __webpack_public_path__ + "static/media/Monolith_Video_No_Zoom_No_Logo.d2353384.jpg";